// extracted by mini-css-extract-plugin
export var actions = "_rp-4";
export var item = "_rp-1";
export var price = "_rp-3";
export var quantity = "_rp-2";
export var table = "_rp-0";